import React from 'react';

const Footer = () => {
  return (
    <footer>
      Developed by &nbsp;
      <a href='https://github.com/shakib1729' target='_blank' rel='noreferrer'>
        Shakib Ahmed
      </a>
    </footer>
  );
};

export default Footer;
